import Result from './Result';
import SearchInput from './SearchInput';

export default function HeaderSearchBar({ items, showResults, onFocus, onBlur }) {
    return (
        <div className="header_search_bar" id="header_search_bar">
            <SearchInput items={items} onFocus={onFocus} onBlur={onBlur} />
            {showResults ? <Result onFocus={onFocus} onBlur={onBlur} /> : <noscript />}
        </div>
    );
}
